<template>
    <form-row title="Has Managing Broker Approved?" :no_border="true" class="mt-6">
        <input-radio-boolean
            name="list_side_broker_approved"
            :value="commission_detail.list_side_broker_approved"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        commission_detail: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
